import React from 'react';
import { connect } from 'react-redux';
import * as S from './PlayOverview.styles';
import * as SL from 'modules/Player/selectors';

export interface IPlayOverviewProps {
  headerText: ReturnType<typeof SL.getShowHeadline>;
  showSubtitle: ReturnType<typeof SL.getShowSubtitle>;
  isShowApiRequestPending: ReturnType<typeof SL.getIsShowApiRequestPending>;
  isTrackApiRequestPending: ReturnType<typeof SL.getIsTrackApiRequestPending>;
  currentlyPlayingTrackHeadline: ReturnType<typeof SL.getCurrentlyPlayingTrackHeadline>;
}

export interface IPlayOverviewState {
  isHovered: boolean;
}

export class PlayOverview extends React.PureComponent<IPlayOverviewProps, IPlayOverviewState> {
  defaultState = {
    isHovered: false,
  };

  state = {
    isHovered: false,
  };

  hoverTimeout: any = 0;

  resetInternalState = () =>
    this.setState((prevState) => {
      if (prevState.isHovered) {
        return { ...this.defaultState };
      }
    });

  onMouseEnter = () => {
    clearTimeout(this.hoverTimeout);

    this.hoverTimeout = setTimeout(() => {
      this.setState(() => {
        return { isHovered: true };
      });
    }, 2000);
  };

  onMouseLeave = () => {
    clearTimeout(this.hoverTimeout);

    this.hoverTimeout = setTimeout(this.resetInternalState, 100);
  };

  render() {
    const {
      headerText = '',
      showSubtitle = '',
      currentlyPlayingTrackHeadline = '',
      isShowApiRequestPending,
      isTrackApiRequestPending,
    } = this.props;
    const { isHovered } = this.state;

    let subHeaderText = currentlyPlayingTrackHeadline || showSubtitle;

    const isPending = isShowApiRequestPending || isTrackApiRequestPending || false;

    let headerTextEvaluated = '';
    if (headerText) {
      headerTextEvaluated = headerText;
    } else if (!isPending) {
      headerTextEvaluated = 'Název pořadu se nepodařilo načíst';
    }

    let subHeaderTextEvaluated = '';
    if (subHeaderText) {
      subHeaderTextEvaluated = subHeaderText;
    } else if (!isPending) {
      subHeaderTextEvaluated = 'Popis pořadu se nepodařilo načíst';
    }

    return (
      <S.PlayOverviewWrapper>
        <S.PlayOverviewTextWrapper
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          onClick={this.onMouseLeave}
        >
          <S.PlayOverviewHeader className="noselect withOverflow" data-testid="PlayOverview-Header">
            {headerTextEvaluated}
          </S.PlayOverviewHeader>
          <S.PlayOverviewSubHeader
            className="noselect withOverflow"
            data-testid="PlayOverview-SubHeader"
          >
            {subHeaderTextEvaluated}
          </S.PlayOverviewSubHeader>
        </S.PlayOverviewTextWrapper>
        {/*TODO - remove hardcoded link to youradio when shows will have their pages*/}
        <S.PlayOverviewLogo href="https://talk.youradio.cz/" title="talk.youradio.cz">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="32"
            height="32"
            viewBox="0 0 32 32"
          >
            <path
              id="you"
              className="cls-1"
              d="M472.023,957.367a4.018,4.018,0,1,0,4.091,4.017A4.054,4.054,0,0,0,472.023,957.367Zm0.023-5.551a9.864,9.864,0,0,0-5.023,1.365l1.331,2.152a7.294,7.294,0,0,1,7.483.06l1.332-2.151A9.862,9.862,0,0,0,472.046,951.816Zm0-3.314a13.284,13.284,0,0,1,6.874,1.912l1.333-2.154a15.96,15.96,0,0,0-16.314-.06l1.333,2.154A13.291,13.291,0,0,1,472.046,948.5Zm13.423,8.685v6.974c-1.577.542-3.667,0.018-3.594-1.878v-5.1h-2.64l0.01,4.267a6.944,6.944,0,0,1-2.105,4.952,7.288,7.288,0,0,1-10.168,0,6.959,6.959,0,0,1-.67-9.219h-3.089l-2.1,5.96-2.4-5.96H456c1.118,2.705,2.489,5.841,3.624,8.563-0.4,1.7-.477,2.059-2.145,2.041v1.86c1.521,0.289,3.556.018,4.253-1.752l1.191-3.044a9.56,9.56,0,0,0,2.218,3.347,9.912,9.912,0,0,0,13.829,0,9.608,9.608,0,0,0,1.932-2.685,5.314,5.314,0,0,0,3.246.992,11.361,11.361,0,0,0,3.85-.687v-8.635h-2.53Z"
              transform="translate(-456 -942.5)"
            />
          </svg>
        </S.PlayOverviewLogo>
        {isHovered ? (
          <S.PlayOverviewTooltip
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            onClick={this.onMouseLeave}
          >
            <S.PlayOverviewHeader className="noselect">{headerTextEvaluated}</S.PlayOverviewHeader>
            <S.PlayOverviewSubHeader className="noselect">
              {subHeaderTextEvaluated}
            </S.PlayOverviewSubHeader>
          </S.PlayOverviewTooltip>
        ) : null}
      </S.PlayOverviewWrapper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  headerText: SL.getShowHeadline(state),
  showSubtitle: SL.getShowSubtitle(state),
  isShowApiRequestPending: SL.getIsShowApiRequestPending(state),
  isTrackApiRequestPending: SL.getIsTrackApiRequestPending(state),
  currentlyPlayingTrackHeadline: SL.getCurrentlyPlayingTrackHeadline(state),
});

export default connect(mapStateToProps, null)(PlayOverview);
